import { Button, ButtonGroup, Card } from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import {
  APP_BASE_URL,
  ASSET_ADDITIONAL_INFO,
  ASSET_REPLACEMENT,
  GET_ASSET_FORM,
  GET_DEVICE_TYPE_ASSET,
} from "../../../Common/EndPoints";
import { getLocalStorage } from "../../../Utils/storage-utils";
import Loader from "../../Loader/Loader";
import { FormField } from "../AssetRegister/FormRender";
// import AssetComponentReplacementHistory from "./AssetComponentReplacementHistory";
// import AssetComponentReplacementHistoryWrapper from "./AssetComponentReplacementHistory";

// enum ActiveTab {
//   COMPONENT_REPLACEMENT = "component-replacement",
//   COMPONENT_REPLACEMENT_HISTORY = "component-replacement-history",
// }

// function AssetComponentReplacementWrapper() {
//   const [activeTab, setActiveTab] = useState<ActiveTab>(ActiveTab.COMPONENT_REPLACEMENT);

//   return (
//     <>
//       <ButtonGroup style={{ marginBottom: "1rem" }}>
//         <Button variant={activeTab === ActiveTab.COMPONENT_REPLACEMENT ? "contained" : "outlined"} onClick={() => setActiveTab(ActiveTab.COMPONENT_REPLACEMENT)}>Component Replacement</Button>
//         <Button variant={activeTab === ActiveTab.COMPONENT_REPLACEMENT_HISTORY ? "contained" : "outlined"} onClick={() => setActiveTab(ActiveTab.COMPONENT_REPLACEMENT_HISTORY)}>Component Replacement History</Button>
//       </ButtonGroup>

//       {activeTab === ActiveTab.COMPONENT_REPLACEMENT && <AssetComponentReplacement />}
//       {activeTab === ActiveTab.COMPONENT_REPLACEMENT_HISTORY && <AssetComponentReplacementHistoryWrapper />}
//     </>
//   )
// }

function AssetComponentReplacementWrapper() {
  const location = useLocation();
  const defaultState = (location?.state as any)?.d;
  const defaultValues = defaultState ?? {};
  const DEVICE_ID = defaultValues?.deviceId;
  const gearTypeValue = useMemo(() => defaultValues?.gearType, [location]);
  const gear_name = useMemo(() => defaultValues?.gear_name, [location]) 

  return (
    <AssetComponentReplacement
      DEVICE_ID={DEVICE_ID}
      gearType={gearTypeValue}
      defaultValues={defaultValues}
      gear_name={gear_name}
    />
  );
}

export function AssetComponentReplacement({
  DEVICE_ID,
  gearType,
  // _defaultValues, 
  defaultValues,
  gear_name
}: {
  DEVICE_ID: string,
  gearType: string,
  gear_name: string,
  defaultValues: any
}) {
  const navigate = useNavigate();
  // const location = useLocation();
  // const defaultState = (location?.state as any)?.d;
  // const defaultValues = defaultState ?? {};
  // const DEVICE_ID = defaultValues?.deviceId;

  const [loading, setLoading] = useState(true);
  const formMethods = useForm({ mode: "onSubmit", defaultValues });
  const { handleSubmit, reset } = formMethods;

  const gearTypeValue = useMemo(() => gearType, []);
  const [deviceTypeCollectionMapIds, setDeviceTypeCollectionMapIds] = useState<any>(null);

  const [form, setForm] = useState<any[]>([]);
  const [subTabList, setSubTabList] = useState<any[]>([]);
  const [selectedSubTab, setSelectedSubTab] = useState<any>(null);
  const [subFormTabs, setSubFormTabs] = useState<any>(null);
  const [selectedSubFormTab, setSelectedSubFormTab] = useState<any>(null);

  const form_keys_map = useMemo(() => {
    const _keys: any = {};
    form?.forEach((field) => (_keys[field.key] = field));
    return _keys;
  }, [form]);

  const providerProps = { form_keys_map };

  useEffect(() => {
    setLoading(true);
    const params = { with_map: true };
    const url = `${APP_BASE_URL}${GET_DEVICE_TYPE_ASSET}`;

    axios.get(url, { params }).then(
      async (res) => {
        const _mapIds: any = {};
        res.data.data.forEach((_deviceType: any) => {
          _mapIds[_deviceType.label] = {
            type_id: _deviceType.typeid,
            collection_map_id: _deviceType?.collectionMaps?.[0]?.collectionmapid,
            type: _deviceType.type,
          };
        });
        setDeviceTypeCollectionMapIds(_mapIds);
        setLoading(false);
      },
      (err) => {
        toast.error("Error Loading Form");
      },
    );
  }, []);

  const formSubmit = async (data: any) => {
    try {
      if (!selectedSubFormTab?.key) {
        toast.error("Please select a component to replace");
        return;
      }
      const userId = getLocalStorage("userId");
      setLoading(true);
      const payload: any = {
        payload: {},
        dor: dayjs(data.dor).valueOf(),
        userId,
        createdTs: Date.now(),
        deviceId: DEVICE_ID,
        formId: selectedSubTab?.id,
        replacementCompId: selectedSubFormTab?.key,
      };
      form?.map(({ key }) => {
        payload.payload[key] = data[key];
      });
      const url = `${APP_BASE_URL}${ASSET_REPLACEMENT}`;
      const res = await axios.post(url, payload);

      toast.success("Form Submitted Successfully");

      navigate(-1);
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        toast.error(error?.response?.data?.error?.message || "Something went wrong");
        return;
      }
      toast.error(error?.message || "Error Submitting Form");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!gearTypeValue || !deviceTypeCollectionMapIds) return;
    setSubTabData(gearTypeValue);

    function setSubTabData(_collection_map_id: string) {
      const collection_map_id = deviceTypeCollectionMapIds?.[_collection_map_id]?.collection_map_id;
      if (!collection_map_id) {
        setSubTabList([]);
        return;
      }

      axios
        .get(`${APP_BASE_URL}${GET_ASSET_FORM}`, {
          params: { collection_map_id: collection_map_id, publish: true },
        })
        .then((res) => {
          const form_id = res.data.data?.[0]?.id;
          setSubTabList(res.data.data);
          const selectedSubTab = res.data.data?.[0];
          setSelectedSubTab(selectedSubTab);

          if (form_id && DEVICE_ID) {
            const url = `${APP_BASE_URL}${ASSET_ADDITIONAL_INFO}`;
            const params = { device_id: DEVICE_ID, form_id };
            axios.get(url, { params }).then((res) => {
              const formData = res.data.data?.[0]?.data;
              const _subFormTabs = filterReplacementSection(selectedSubTab?.data, formData);
              reset(formData);

              setSubFormTabs(_subFormTabs);
              const selectedSubFormTab = _subFormTabs?.[0];

              setSelectedSubFormTab(selectedSubFormTab);

              setForm(selectedSubFormTab?.sectionFields);
            });
          }
        });
    }
  }, [gearTypeValue, deviceTypeCollectionMapIds]);

  const filterReplacementSection = (section: any | undefined, formData: any) => {
    return section && Array.isArray(section)
      ? section?.filter((_subTab: any) => {
        if (!_subTab?.isComponentSection) {
          return false;
        }
        if (_subTab.type == "section") {
          return true;
        }
        if (_subTab.type == "reactive_section") {
          const reactiveKey = _subTab.reactiveKey;
          const reactiveKeyValue = formData?.[reactiveKey];
          if (!reactiveKeyValue) {
            return false;
          }

          const checkReactiveValue = (value: string | string[], target: string | string[]): boolean => {
            if (Array.isArray(value)) {
              return Array.isArray(target) ? target.some((t) => value.includes(t)) : value.includes(target);
            } else {
              return Array.isArray(target) ? target.includes(value) : value === target;
            }
          };

          return checkReactiveValue(reactiveKeyValue, _subTab.reactiveValue);
        }
        return false;
      })
      : [];
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="p-2">
      <Card sx={{ padding: "1rem", marginBottom: "1rem" }}>
        <p>
          <span style={{ fontWeight: "bold" }}>Asset Name:</span> <span>{gear_name}</span>
        </p>
      </Card>
      <ButtonGroup
        variant="outlined"
        aria-label="outlined button group"
        style={{ display: "block", marginBottom: "1rem" }}
      >
        {subTabList.map((_subTab) => (
          <Button
            variant={selectedSubTab?.id === _subTab?.id ? "contained" : "outlined"}
            key={_subTab.id}
            onClick={() => {
              setSelectedSubTab(_subTab);
              const _subFormTabs = filterReplacementSection(_subTab.data?.[0], {});
              setSubFormTabs(_subFormTabs);
              setSelectedSubFormTab(_subFormTabs?.[0]);
            }}
          >
            {_subTab.name}
          </Button>
        ))}
      </ButtonGroup>
      <ButtonGroup variant="text" aria-label="outlined button group" style={{ display: "block", marginBottom: "1rem" }}>
        {subFormTabs?.map((_subForm: any) => (
          <Button
            // variant={selectedTab === _subTab.id ? "contained" : "outlined"}
            key={_subForm.key}
            variant={selectedSubFormTab?.key === _subForm?.key ? "contained" : "outlined"}
            onClick={() => {
              setSelectedSubFormTab(_subForm);
              setForm(_subForm.sectionFields);
            }}
          >
            {_subForm.label}
          </Button>
        ))}
      </ButtonGroup>
      {form ? (
        <FormProvider {...formMethods} {...providerProps}>
          <form onSubmit={handleSubmit(formSubmit)}>
            <div className="assets__asset-register__form flex flex-col gap-2">
              {form?.map((field) => (
                <FormField handleBlur={() => { }} key={field.key} fieldData={field} />
              ))}
              <FormField
                handleBlur={() => { }}
                key={"dor"}
                fieldData={{
                  type: "date",
                  key: "dor",
                  label: "Date of Replacement",
                  required: true,
                }}
              />
            </div>
            <div className="flex justify-between" style={{ marginTop: "1rem" }}>
              <Button type="submit" variant="contained">
                Submit
              </Button>
            </div>
          </form>
        </FormProvider>
      ) : (
        <div>No Component found</div>
      )}
    </div>
  );
}

export default AssetComponentReplacementWrapper;
